module.exports = __webpack_public_path__ + "img/paymentSuccessful.ed7e4d51.png";